(() => {
  const main = document.querySelector('main');
  if (!main) return;
  const productKey = href => {
    try { return new URL(href, location.origin).pathname.match(/\/products\/([^/]+)/)?.[1] || ''; }
    catch { return ''; }
  };
  const current = productKey(location.href);
  if (!current) return;
  const nativeSelector = '[data-gb-picks-list] > li, [data-gb-merch-collection] li[data-gb-product-id], [id*="recently_viewed_products"] li';
  const style = document.createElement('style');
  style.textContent = `
    [data-gb-suggestion-duplicate],[data-gb-suggestion-grid][hidden]{display:none!important}
    [data-gb-suggestion-grid]{grid-template-columns:repeat(2,minmax(0,1fr))!important}
    [data-gb-suggestion-grid] > li:not([data-gb-suggestion-duplicate]){
      grid-column:span var(--gb-suggestion-mobile-span,1)!important;min-width:0
    }
    @media(min-width:1024px){
      [data-gb-suggestion-grid]{grid-template-columns:repeat(12,minmax(0,1fr))!important}
      [data-gb-suggestion-grid] > li:not([data-gb-suggestion-duplicate]){
        grid-column:span var(--gb-suggestion-desktop-span,3)!important
      }
    }
  `;
  document.head.append(style);
  let pending = false;
  function deduplicate() {
    pending = false;
    const used = new Set([current]);
    // Keep the personalised Rebuy suggestions, then remove repeats in native grids.
    main.querySelectorAll('[data-rebuy-id] .rebuy-product-block:not(.splide__slide--clone)').forEach(card => {
      const key = productKey(card.querySelector('a[href*="/products/"]')?.href);
      if (key) used.add(key);
    });
    const grids = new Set();
    main.querySelectorAll(nativeSelector).forEach(card => {
      if (card.parentElement.hasAttribute('data-gb-suggestion-grid') || getComputedStyle(card.parentElement).display === 'grid') grids.add(card.parentElement);
      const key = productKey(card.querySelector('a[href*="/products/"]')?.href);
      if (!key) return;
      const duplicate = used.has(key);
      card.toggleAttribute('data-gb-suggestion-duplicate', duplicate);
      if (!duplicate) used.add(key);
    });
    // Rebalance each remaining row so removed duplicates cannot leave black cells.
    grids.forEach(grid => {
      const cards = Array.from(grid.children).filter(card =>
        card.matches('li') && !card.hasAttribute('data-gb-suggestion-duplicate'));
      grid.setAttribute('data-gb-suggestion-grid', '');
      let offset = 0;
      while (offset < cards.length) {
        const remaining = cards.length - offset;
        const rowSize = remaining === 5 || remaining === 6 ? 3 : Math.min(4, remaining);
        for (let index = offset; index < offset + rowSize; index++) {
          cards[index].style.setProperty('--gb-suggestion-desktop-span', 12 / rowSize);
          cards[index].style.setProperty('--gb-suggestion-mobile-span',
            cards.length % 2 && index === cards.length - 1 ? 2 : 1);
        }
        offset += rowSize;
      }
      // Hide an empty list as well as its cards.
      grid.hidden = cards.length === 0;
    });
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(deduplicate);
  }
  new MutationObserver(schedule).observe(main, {childList:true, subtree:true});
  ['rebuy.ready', 'rebuy.productsChange', 'shopify:section:load'].forEach(name => document.addEventListener(name, schedule));
  schedule();
})();
